import * as yup from "yup";
import Toast from "helper/toast";

//////////////////// file sizes and formates ////////////////////
export const FILE_SIZE = 10_000_000; //10 meg

//////////////////// constant validation message ////////////////////
function strings({ title = "فیلد", size = "۵ مگ" }) {
  return {
    required: "این فیلد حتما باید پر شود",
    notMatch: title + " نامعتبر است ",
    size: `سایز ${title} باید کمتر از ${size} باشد`,
    min: `${title} حداقل باید ${size} کاراکتر باشد`,
    unSupported: `فرمت ${title} نامعتبر است`,
  };
}

/////////////////// convert empty stringToNull ///////////////////
function emptyStringToNull(value, originalValue) {
  if (typeof originalValue === "string" && originalValue === "") {
    return null;
  }
  return value;
}

///////////////// Image validator ///////////////////
export function validateImg(file) {
  if (!(file.type.split("/")[0] === "image")) {
    return Toast({
      type: "custom",
      title: `فرمت عکس نامعبتر است`,
      autoClose: 3000,
    });
  } else if (file.size > FILE_SIZE) {
    return Toast({
      type: "custom",
      //converting kb to megabyte
      title: `حجم عکس باید کمتر از ${FILE_SIZE / 1_000_000}  مگ باشد`,
      autoClose: 3000,
    });
  }
}

////////////////// privacy ///////////////////
export const privacySchema = yup
  .object({
    text: yup.string().required(strings("").required),
  })
  .required();

////////////////// contactUsContent ///////////////////
export const contactUsContentSchema = yup
  .object({
    phone_number: yup.string().required(strings("").required),
    address: yup.string().required(strings("").required),
    instagram: yup.string().required(strings("").required),
    telegram: yup.string().required(strings("").required),
    email: yup.string().required(strings("").required),
  })
  .required();

////////////////// article  //////////////////
export const articleSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    // text: yup.string().required(strings("").required),
  })
  .required();

/////////////// common Question ///////////////
export const commonQuestionSchema = yup
  .object({
    question: yup.string().required(strings("").required),
    answer: yup.string().required(strings("").required),
  })
  .required();

////////////////// category ///////////////////
export const CategorySchema = yup
  .object({
    title: yup.string().required(strings("").required),
  })
  .required();

////////////////// products  //////////////////
export const prodcutSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    link: yup.string().transform(emptyStringToNull).nullable(),
    before_discount_price: yup.string().required(strings("").required),
    colleague_price: yup.string().required(strings("").required),
    discount_percent: yup.string(),
    description: yup.string().transform(emptyStringToNull).nullable(),
    type: yup.string(),
  })
  .required();

////////////////// products  //////////////////
export const prodcutColorSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    color_code: yup.string(),
    stock: yup.string().required(strings("").required),
  })
  .required();

////////////////// homeProduct ///////////////////
export const dicountSchema = yup
  .object({
    amount: yup.string().required(strings("").required),
    code: yup.string().required(strings("").required),
  })
  .required();

/////////////// SingUp ///////////////
export const signUpSchema = yup
  .object({
    full_name: yup.string().required(strings("").required),
    phone_number: yup
      .string()
      .required(strings("").required)
      .matches(
        /^[\u06F0-\u06F90-9]+$/,
        strings({ title: "نلفن همراه" }).notMatch
      )
      .min(11, strings({ title: "نلفن همراه" }).notMatch)
      .max(11, strings({ title: "نلفن همراه" }).notMatch),
    password: yup
      .string()
      .required(strings("").required)
      .min(6, strings({ title: "رمز عبور", size: 6 }).min),
    state: yup.string().nullable(),
    city: yup.string().nullable(),
    email: yup.string().nullable(),
    postal_code: yup.string().nullable(),
    type: yup.string().required(strings("").required),
    address: yup.string().nullable(),
  })
  .required();

/////////////// Edit User ///////////////
export const editUserSchema = yup
  .object({
    full_name: yup.string().required(strings("").required),
    phone_number: yup
      .string()
      .required(strings("").required)
      .matches(
        /^[\u06F0-\u06F90-9]+$/,
        strings({ title: "نلفن همراه" }).notMatch
      )
      .min(11, strings({ title: "نلفن همراه" }).notMatch)
      .max(11, strings({ title: "نلفن همراه" }).notMatch),
    // state: yup.string().transform(emptyStringToNull).nullable(),
    // city: yup.string().transform(emptyStringToNull).nullable(),
    email: yup.string().email().transform(emptyStringToNull).nullable(),
    // postal_code: yup.string().transform(emptyStringToNull).nullable(),
    // type: yup
    //   .string()
    //   .required(strings("").required)
    //   .transform(emptyStringToNull)
    //   .nullable(),
    // address: yup.string().transform(emptyStringToNull).nullable(),
    password: yup
      .string()
      .min(6, strings({ title: "رمز عبور", size: 6 }).min)
      .transform(emptyStringToNull)
      .nullable(),
  })
  .required();

/////////////// Edit normal User ///////////////
export const editNormalUserSchema = yup
  .object({
    full_name: yup.string().required(strings("").required),
    email: yup.string().email().transform(emptyStringToNull).nullable(),
  })
  .required();

////////////////// contactUsContent ///////////////////
export const editAddressUserSchema = yup
  .object({
    state: yup.string().required(strings("").required),
    address: yup.string().required(strings("").required),
    city: yup.string().required(strings("").required),
    postal_code: yup.string().required(strings("").required),
  })
  .required();

////////////////// Frame ///////////////////
export const FrameSchema = yup
  .object({
    title: yup.string().required(strings("").required),
    text: yup.string().required(strings("").required),
  })
  .required();

/////////////// notification frame ///////////////
export const NotificationSchema = yup
  .object({
    text: yup.string().required(strings("").required),
  })
  .required();

/////////////// add ticket message ///////////////
export const EditTicketSchema = yup
  .object({
    text: yup.string().required(strings("").required),
  })
  .required();

////////////////// Answer  //////////////////
export const addAnswerSchema = yup
  .object({
    answer: yup.string().required(strings("").required),
  })
  .required();
